import React from 'react';

import { required } from '@swf/core/utils/validators';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Place_of_issue,
  TXTWCL_Please_enter_your_information__ELL
} from './PlaceOfIssueField.messages.json';

const PlaceOfIssueField: React.FC = () => (
  <TextInput
    id="docIssuePlace"
    label={TXTWCL_Place_of_issue}
    validators={[required(TXTWCL_Please_enter_your_information__ELL)]}
    checkDisabled
  />
);

export default PlaceOfIssueField;
